/**
 * Given a filters object, returns a list of years as integers which should be
 * displayed.
 * @param {object} disambiguatedFilters - The disambiguated filters object to analyze.
 * @returns {number[]} An array of integers to be displayed.
 */
const getYearsFromFilters = ({
  yearCompare,
  yearRange: [start, end],
  yearSingle,
  yearType,
}) => {
  if (yearType === 'Single Year') {
    return [yearSingle];
  }

  if (yearType === 'Compare Two Years') {
    return yearCompare;
  }

  // If the range is invalid, bail out.
  if (typeof start !== 'number'
    || typeof end !== 'number'
    || Number.isNaN(start)
    || Number.isNaN(end)
    || start > end
  ) {
    return [];
  }

  // Build an array of years from start to end inclusive.
  const years = [];
  for (let year = start; year <= end; year += 1) {
    years.push(year);
  }

  return years;
};

export default getYearsFromFilters;
